import type { ReactNode } from 'react';
import { useState, useCallback } from 'react';
import type { WalletRechargeQuota } from '@/pages/Wallet/interface';
import { getPayoneerOauthUrl, getPayoneerUserInfo } from '@/services/wallet';

export default function useWalletModel() {
  const [error, setError] = useState<ReactNode | null>(null);
  const [loading, setLoading] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);

  // 用户授权信息
  const [payoneerUserInfo, setPayoneerUserInfo] =
    useState<WalletRechargeQuota.Response.PayoneerUserInfo>();
  // 授权链接
  const [payoneerAuthUrl, setPayoneerAuthUrl] =
    useState<WalletRechargeQuota.Response.PayoneerAuthUrl>();
  // 错误信息
  const [payoneerError, setPayoneerError] = useState<string>();
  // 是否显示授权提示
  const [payoneerTips, setPayoneerTips] = useState<boolean>(false);

  // 获取用户授权信息
  const getPayoneerInfo = useCallback(async () => {
    setLoading(true);
    const [userInfo, userInfoErr] = await getPayoneerUserInfo();
    setError(userInfoErr);
    if (userInfo) {
      setPayoneerUserInfo(userInfo);
    }
    setLoading(false);
  }, []);

  // 获取授权链接
  const getPayoneerOauth = useCallback(async () => {
    setAuthLoading(true);
    const [authUrl, authUrlErr] = await getPayoneerOauthUrl();
    setError(authUrlErr);
    if (authUrl) {
      // @ts-ignore history code
      setPayoneerAuthUrl(authUrl?.oauth_url);
    }
    setAuthLoading(false);
  }, []);

  // 显示授权提示
  const changePayoneerTips = () => {
    if (!payoneerUserInfo?.status || payoneerError) {
      setPayoneerTips(true);
    }
  };

  return {
    error,
    loading,
    authLoading,

    payoneerUserInfo,
    getPayoneerInfo,
    payoneerAuthUrl,
    setPayoneerAuthUrl,
    getPayoneerOauth,
    payoneerError,
    setPayoneerError,
    payoneerTips,
    setPayoneerTips,
    changePayoneerTips,
  };
}
